import '../jquery'

let cart_ready;

cart_ready = function () {
  return $(document).on("ajax:success", "#cart", function (e, data, status, xhr) {
    console.log("result!");
    return $("#cart_page").replaceWith(xhr.responseText);
  }).on("ajax:error", function (e, xhr, status, error) {
    return console.log(error);
  });
};

$(document).ready(cart_ready);

$(document).on('turbo:load', cart_ready);
